export default __webpack_public_path__ + "static/media/935.c44b1b16.gif";